import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase2 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    date: '2025-07-01',
                    mau: 831381,
                    new_users: 314516,
                    dates: 31,
                    avg_monthly_dau: 240767.4516129032,
                },
                {
                    date: '2025-08-01',
                    mau: 985529,
                    new_users: 478313,
                    dates: 31,
                    avg_monthly_dau: 251006.93548387097,
                },
                {
                    date: '2025-09-01',
                    mau: 782363,
                    new_users: 309539,
                    dates: 18,
                    avg_monthly_dau: 263021.27777777775,
                },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
